// extracted by mini-css-extract-plugin
module.exports = {"yoho":"yoho-module--yoho--2bgwM","fineprint":"yoho-module--fineprint--385WH"};